import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import Quote from 'src/components/Quotes';
import { Box } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer,
        color: '#fff',
    },
}));

export default function SimpleBackdrop({ loading }) {
    const classes = useStyles();

    return (
        <Backdrop className={classes.backdrop} open={loading}>
            <Box
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 30,
                }}
            >
                <CircularProgress color="inherit" />
                <Quote />
            </Box>
        </Backdrop>
    );
}
